module.exports = __webpack_public_path__ + "img/certificate-1-lg@3x.9c48c0cc.png";